/** Shared number formatting for the Strategy Automation tab. */

export const fmtUsd = (n) =>
  n == null || isNaN(Number(n))
    ? "—"
    : `$${Number(n).toLocaleString("en-US", { maximumFractionDigits: 0 })}`;

export const fmtPriceUsd = (n) =>
  n == null || isNaN(Number(n))
    ? "—"
    : `$${Number(n).toLocaleString("en-US", { maximumFractionDigits: 2 })}`;

export const fmtUsdc = (n) =>
  n == null || isNaN(Number(n))
    ? "—"
    : `${Number(n).toLocaleString("en-US", { maximumFractionDigits: 2 })} USDC`;

export const fmtUsdSigned = (n) =>
  n == null || isNaN(Number(n))
    ? "—"
    : `${Number(n) > 0 ? "+" : Number(n) < 0 ? "−" : ""}$${Math.abs(Number(n)).toLocaleString(
        "en-US",
        { maximumFractionDigits: 0 }
      )}`;

export const fmtPct = (n, { signed = false } = {}) =>
  n == null || isNaN(Number(n))
    ? "—"
    : `${signed && Number(n) > 0 ? "+" : ""}${Number(n).toLocaleString("en-US", {
        maximumFractionDigits: 1,
      })}%`;

/* "2026-07" → "Jul 2026". Split by hand — Date parsing of a bare "YYYY-MM"
   string is UTC and can shift a month in negative-offset timezones. */
export const fmtMonthLabel = (ym) => {
  const m = /^(\d{4})-(\d{2})$/.exec(ym || "");
  if (!m) return ym || "—";
  return new Date(Number(m[1]), Number(m[2]) - 1, 1).toLocaleDateString("en-US", {
    month: "short",
    year: "numeric",
  });
};

export const clamp = (n, min, max) => Math.min(max, Math.max(min, n));

export const shortAddr = (a) =>
  !a ? "" : a.length <= 14 ? a : `${a.slice(0, 6)}…${a.slice(-4)}`;
